import React from "react";

import { useNavigate } from "react-router-dom";
import { HOME } from "src/constants/routes";
import { EMPTY_MARKET_PLACE } from "src/constants/images";

const ErrorPage = () => {
  const navigate = useNavigate();

  return (
    <div className="error-page text-center">
      <h1 className="mb-0">404!</h1>
      <h4>Looks like page doesn't seems to exist.</h4>
      <div>
        <img src={EMPTY_MARKET_PLACE.SOURCE} alt="empty market-place" />
      </div>
      <button
        className="btn btn-primary"
        onClick={() => navigate(HOME.INDEX)}
      >
        Navigate back Home
      </button>
    </div>
  );
};

export default ErrorPage;
